import { useEffect, useRef, useState } from "react";
import { MyServicesIcon } from "../../../../../Assets/Icons";
import { useGeneralHooks } from "../../../../../Hooks/hooks";
import { BusinessServices, IBusinessServicesNavs, } from "../../../../../Interfaces/componentTypes";
import { ISevicesProps } from "./services";
import MyServices from "./Contents/MyServices/myServices";

const useServicesHook = (props: ISevicesProps) => {
    const { data,onUpdate } = props;
    const { t, largeScreen } = useGeneralHooks();
    const [activeContent, setActiveContent] = useState<BusinessServices>(BusinessServices.MY_SERVICES);
    const navRef = useRef<HTMLDivElement>(null);
    const navItemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleNavClick = (index: number, id: BusinessServices) => {
        setActiveContent(id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const currentUrl = window.location.href.split('?')[0];
        window.history.pushState({}, '', `${currentUrl}?tab=${id}`);

        if (navItemRefs.current[index] && navRef.current && !largeScreen) {
            navItemRefs.current[index]?.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
        }
    };
    const serviceActions: IBusinessServicesNavs[] = [
        {
            id: BusinessServices.MY_SERVICES,
            title: t('My_Business.My_Services.Title'),
            icon: MyServicesIcon,
        },
    ];

    useEffect(() => {
        scrollTop()
    }, [activeContent]);

    const PAGE_CONTENTS = {
        [BusinessServices.MY_SERVICES]: (
            <MyServices
                data={data}
                onUpdate={onUpdate}
            />
        ),
    };

    return {
        navRef,
        navItemRefs,
        PAGE_CONTENTS,
        activeContent,
        serviceActions,
        handleNavClick,
    }
};

export default useServicesHook